import * as React from "react";
import SoftManagement from "./lists/entry";

export default function Feelings({ Icon, path, label }) {
  return <SoftManagement Icon={Icon} path={path} label={label} />;
}
